import React, { useState } from "react";

import "../../styles/components/ToolBarLeftPanel.scss";
import { useTranslation } from "react-i18next";

import ClearText from "../../images/ClearText.svg";

import warning from "../../images/warning.svg";

import {
  RECTANGLE,
  CIRCLE,
  TRIANGLE,
  POLYGON,
  HEXAGON,
} from "../../Uitls/ComponentType";
import Hexagon from "../../images/Shapes/Hexagon.svg";
import Polygon from "../../images/Shapes/Polygon.svg";
import Circle from "../../images/Shapes/Circle.svg";
import Triangle from "../../images/Shapes/Triangle.svg";
import Rectangle from "../../images/Shapes/Rectangle.svg";
import RectangleHover from "../../images/Shapes/RectangleHover.svg";
import HexagonHover from "../../images/Shapes/HexagonHover.svg";
import PolygonHover from "../../images/Shapes/PolygonHover.svg";
import CircleHover from "../../images/Shapes/CircleHover.svg";
import TriangleHover from "../../images/Shapes/TriangleHover.svg";

const ShapesWindow = (props) => {
  const { handleCloseElement, getLayerDetails } = props;
  const { t } = useTranslation();

  const shapesDetails = [
    { name: "Rectangle", id: RECTANGLE, image: Rectangle, imageHover: RectangleHover },
    { name: "Circle", id: CIRCLE, image: Circle, imageHover: CircleHover },
    { name: "Triangle", id: TRIANGLE, image: Triangle, imageHover: TriangleHover },
    { name: "Polygon", id: POLYGON, image: Polygon, imageHover: PolygonHover },
    { name: "Hexagon", id: HEXAGON, image: Hexagon, imageHover: HexagonHover },
  ];
  const [hoveredImage, setHoveredImage] = useState(null);

  const handleMouseEnter = (id) => {
    setHoveredImage(id);
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  return (
    <div className="parentContainerShapes">
      <div className="shapesContainer">
        {/* <div className="headingrow">
          <div>
            <span>{t("SHAPE")}</span>
            <img alt="" src={warning} className="img-fluid warningIcon" />
          </div>
          <img
            src={ClearText}
            alt=""
            className="clearTextIcon clearText"
            onClick={() => handleCloseElement("Shapes")}
          />
        </div> */}
        <div className="shapes">
          {shapesDetails.map((shape) => (
            <div className="shapesHolder">
              <div
                key={shape.id}
                id={shape.id}
                style={{
                  cursor: "pointer",
                  backgroundImage: `url(${hoveredImage === shape.id ? shape.imageHover : shape.image})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  height: "58px",
                  width: "221px",
                }}
                className="img-fluid"
                draggable={true}
                onDragStart={(e) => {
                  getLayerDetails(e.target.id, shape.id);
                }}
                onDragEnd={() => {
                  getLayerDetails("", "");
                }}
                onMouseEnter={() => handleMouseEnter(shape.id)}
                onMouseLeave={handleMouseLeave}
              />

            </div>

          ))}
        </div>
      </div>
    </div>
  );
};

export default ShapesWindow;
